<template>
  <div class="header uk-margin-small-top uk-margin-bottom uk-container">
    <div class="uk-width-1-1">
      <div uk-grid>
        <div class="uk-width-1-3 uk-inline">
          <button
            class="offcanvas-button uk-padding-remove"
            style="margin-top: 0.5rem;"
            type="button"
            uk-toggle="target: #offcanvas-slide"
          >
            <span uk-icon="icon: menu; ratio: 2"></span>
          </button>
        </div>
        <div class="uk-width-1-3 uk-text-center uk-padding-remove uk-margin-small-top">
          <h3 class="text-synergy-red">{{this.$route.name}}</h3>
        </div>
        <div class="uk-width-expand uk-text-right">
          <img
            alt="Synergy logo"
            src="../assets/synergy-logo.png"
            class="logo"
          />
        </div>
      </div>
    </div>
    <div
      id="offcanvas-slide"
      uk-offcanvas="mode: slide; overlay: true;"
      class=""
    >
      <div class="uk-offcanvas-bar">
        <button class="uk-offcanvas-close" type="button" uk-close></button>

        <h2>Communications Hub</h2>
        <app-navlist></app-navlist>
      </div>
    </div>
  </div>
</template>

<script>
import NavList from "../components/NavList";

export default {
  name: "Header",
  components: {
    appNavlist: NavList
  },
  data:() => ({
  }),
  computed: {
    showOffcanvasMenu() {
      if (this.$route.name != "Login" && this.$route.name != "LoginReset") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/variables.less";

.logo {
  max-height: 40px;

  @media (min-width: @breakpoint-medium) {
    max-height: 50px;
  }
}

.offcanvas-button,
.offcanvas-button:focus {
  border: none;
  background: none;
  color: @color-dim-gray;
  outline-color: @color-white;
}
</style>
